import React from 'react';
import { CheckIcon } from 'lucide-react';
const items = ['The 6 complete digital volumes, ready to teach from', 'Sequences, adaptations, and cueing scripts in every book', 'Real scripts for the exact moments your mind goes blank', 'Ready-made class descriptions, bios, and marketing templates', 'Print-ready and digital-ready — use it on paper or on screen'];
export function InstantAccess() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-24" data-id="element-127" data-mp="1hi890fg537f6">
      <div className="mx-auto max-w-3xl" data-id="element-128" data-mp="1m9q1sg80e1p2">
        <h2 className="text-center text-2xl font-extrabold tracking-tight text-teal sm:text-4xl" data-id="element-129" data-mp="1marojhye0cmm">
          <span aria-hidden="true" data-id="element-130" data-mp="17meoa8s9o7mb">⚡</span> What Do You Get Instantly?
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-131" data-mp="1cl85ocaocirr">
          {items.map(item => <li key={item} className="flex items-start gap-4 rounded-2xl border border-sage/25 bg-cream-card px-6 py-5" data-id="element-132" data-mp="ykniz51n22sz">
              <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-sage" data-id="element-133" data-mp="13ll1xjuh30vj">
                <CheckIcon className="h-3.5 w-3.5 text-cream" aria-hidden="true" data-id="element-134" data-mp="1w6fjabz0y12s" />
              </span>
              <span className="text-[15px] leading-relaxed text-ink" data-id="element-135" data-mp="262qwr5acowyt">{item}</span>
            </li>)}
        </ul>

        <p className="mt-8 text-center text-lg font-bold text-terracotta" data-id="element-136" data-mp="2135yyy6x2uno">
          You never run out of material.
        </p>
      </div>
    </section>;
}